import ApplicationInstance from '@ember/application/instance';
import IntlService from 'ember-intl/services/intl';
import config from 'uplisting-frontend/config/environment';
import { application } from 'uplisting-frontend/utils/application';

interface IIntlAlike {
  t(key: string): string;
}

export function getIntl(): IntlService | IIntlAlike {
  if (!config.IS_TEST) {
    return (application.instance as ApplicationInstance).lookup(
      'service:intl',
    ) as IntlService;
  }

  return {
    t(key: string): string {
      return key;
    },
  };
}
